import { commonTabs } from "containers/Sales/TeamIntelligence/tabs";
import { TeamIcon } from "@icons";
import { permissionTypes } from "hooks/usePermissions";
import l from "@loadable/component";
import TeamPerformanceBreadCrumbs from "components/PlatformLayout/components/PlatformPageHeader/Breadcrumbs/TeamPerformanceBreadCrumbs";

const content = l(() => import("containers/Sales/TeamIntelligence"));

const { TEAM_VIEW, PREVIEW_USER } = permissionTypes;

export default {
  key: "team-performance",
  title: TeamPerformanceBreadCrumbs,
  path: "/team-performance/:tab?/:userId?/:drawerTab?",
  linkTarget: "/team-performance",
  linkTitle: "Team Performance",
  linkCategory: "Sales",
  icon: TeamIcon,
  basePath: "team-performance",
  requiredParams: ["tab"],
  optionalParams: [],
  tabs: commonTabs,
  content,
  permission: [TEAM_VIEW, PREVIEW_USER],
};
